import { network } from 'services/network';

import { User } from 'api/endPoints/getReport';
import { QueryResponse } from 'api/queries/getReportList.query';
import { QueryResponse as Tag } from 'api/queries/getReportsTags.query';

export const getReportList = ({ filter }: QueryParams): Promise<QueryResponse> => {
    const url = `api/bo/reporting/getReportList`;
    return network.post(url, filter).then((response) => {
        return response.data;
    });
};

interface Filter {
    filters: Filters[];
}

interface Filters {
    name: string;
    data: string[];
}

export interface QueryParams {
    filter: Filter;
}

export interface ReportList {
    projContrDetails: ProjContrDetails[];
    accessList: User[] | null;
    description: string;
    id: number;
    isAccessListDefault: boolean;
    lastUpdateDate: number;
    lastUpdateUser: Omit<User, 'isSelected' | 'selected' | 'projectsList'>;
    name: string;
    shareList: User[] | null;
    isMyFavorite: boolean;
    tags: Tag[];
}

export interface ProjContrDetails {
    projectName: string;
    contractName: string;
    lastUploadedVersionDate: number;
}
